<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active">
                <router-link to="/kr/findId"> 
                    아이디 찾기
                </router-link>
            </li>
            <li class="tab-menu__item">
                <router-link to="/kr/findPw">
                    비밀번호 찾기
                </router-link>
            </li>
        </ul>
    </div>
    <div class="find-id">
        <div class="info">
            <div class="text-box">
                <p>
                    * 네이버ID로 가입하신 경우 아이디가 메일 주소로 표시됩니다. <br>
                    메일 주소 아이디를 안내받으셨다면 네이버ID로 로그인해 주세요.
                </p>
            </div>
        </div>

        <div class="find-box info">
            <div class="box">
                <div class="box__inner">
                    <h4><span>휴대전화</span> 인증</h4>
                    <div class="box__input">
                        <label>
                            <span>이름</span>
                            <input type="text" class="input" placeholder="이름을 입력해 주세요." v-model="pName">
                        </label>
                        <label>
                            <span>휴대전화번호</span>
                            <input type="text" class="input" placeholder="‘_’ 제외하고 입력해 주세요." v-model="phone" @keyup.enter="findId('phone')" @input="this.$commonUtils.numberOnly">
                        </label>
                    </div>
                    <div class="botton-wrap">
                        <button type="submit" class="main-button c-main" @click="findId('phone')">아이디 찾기</button>
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="box__inner">
                    <h4><span>이메일</span> 인증</h4>
                    <div class="box__input">
                        <label>
                            <span>이름</span>
                            <input type="text" class="input" placeholder="이름을 입력해 주세요." v-model="eName">
                        </label>
                        <label>
                            <span>이메일</span>
                            <input type="text" class="input" placeholder="이메일을 입력해 주세요." v-model="email" @keyup.enter="findId('email')">
                        </label>
                    </div>
                    <div class="botton-wrap">
                        <button type="submit" class="main-button c-main" @click="findId('email')">아이디 찾기</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <kr_FindIdPopup ref="findPopup" returnId/>
</template>
<script>
    export default {
        data() {
            return {
                pName: '',
                phone: '',
                eName: '',
                email: '',
                returnId: '',
            }
        },
        mounted() {
            
        },
        methods: {
            findId(type){
                const param1 = type == 'phone' ? this.pName : this.eName
                const param2 = type == 'phone' ? this.phone : this.email
                if(!param1){
                    alert('이름을 입력해주시길 바랍니다.')
                    return
                }
                if(!param2){
                    alert(`${type == 'phone' ? '휴대전화번호' : '이메일'}을(를) 입력해주시길 바랍니다.`)
                    return
                }
                const param = {
                    name: param1,
                    ...(type === 'phone' ? { hpNo: param2 } : { email: param2 })
                }
                this.axios.get(this.api.member.findId, {params: param})
                .then(res => {
                    const data = res.data
                    if(data.status){
                        this.$refs.findPopup.popupShow = true
                        this.$refs.findPopup.idList = data.idList
                    }else{
                        alert(data.message)
                    }
                })
                .catch(err => {
                    alert('오류가 발생했습니다.')
                    location.reload()
                })
            },
        },
    }
</script>
<style>

</style>